
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MergingItemsDialog extends Serenity.EntityDialog<MergingItemsRow, any> {
        protected getFormKey() { return MergingItemsForm.formKey; }
        //protected getIdProperty() { return MergingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return MergingItemsRow.localTextPrefix; }
        //protected getNameProperty() { return MergingItemsRow.nameProperty; }
        //protected getService() { return MergingItemsService.baseUrl; }
        protected getDeletePermission() { return MergingItemsRow.deletePermission; }
        protected getInsertPermission() { return MergingItemsRow.insertPermission; }
        protected getUpdatePermission() { return MergingItemsRow.updatePermission; }

        protected form = new MergingItemsForm(this.idPrefix);

    }
}